<template>
<Header class="topnav">

  <div class="header-brand">
    <router-link to="/" class="logo"></router-link>
  </div>

  <Dropdown class="menu-item service-selection">
    <a href="javascript:void(0)" v-if="$store.state.auth.user">
      <div class="menu-item-icon"><Icon type="ios-apps-outline" /></div>
      <div class="menu-item-text">
        <div class="menu-item-name">SERVICE</div>
        <span class="menu-item-link">Meeting</span>
      </div>
    </a>
    <DropdownMenu slot="list" v-if="$store.state.auth.user">
      <DropdownItem v-if="$store.state.auth.user.role=='admin'"><router-link to="/user/new">Webcast</router-link></DropdownItem>
      <DropdownItem v-if="$store.state.auth.user.role=='admin'"><router-link to="/user/list">Meeting</router-link></DropdownItem>
    </DropdownMenu>
  </Dropdown>

  <Dropdown class="menu-item user-menu">
    <a href="javascript:void(0)" v-if="$store.state.auth.user">

      <div class="menu-item-icon"><Icon type="ios-contact" /></div>
      <div class="menu-item-text">
        <div class="menu-item-name">USER</div>
        <span class="menu-item-link">{{$store.state.auth.user.fullName}}</span>
      </div>
    </a>
    <DropdownMenu slot="list" v-if="$store.state.auth.user">
      <DropdownItem v-if="$store.state.auth.user.role=='admin'"><router-link to="/user/new">Create User</router-link></DropdownItem>
      <DropdownItem v-if="$store.state.auth.user.role=='admin'"><router-link to="/user/list">User List</router-link></DropdownItem>
      <DropdownItem v-if="$store.state.auth.user.role=='admin'"><router-link to="/account/new">Create Account</router-link></DropdownItem>
      <DropdownItem><router-link to="/account/select">Account List</router-link></DropdownItem>
      <DropdownItem v-if="$store.state.auth.user.role=='admin'"><router-link to="/app-settings">App Settings</router-link></DropdownItem>
      <DropdownItem><router-link to="/logout">Logout</router-link></DropdownItem>
    </DropdownMenu>
  </Dropdown>
  <div class="menu-item account-selection">
    <div class="menu-item-icon"><Icon type="ios-ionic" /></div>
    <div class="menu-item-text">
      <div class="menu-item-name">ORG</div>
      <router-link class="menu-item-link" v-if="$store.state.account.copy" to="/account/select">
        {{$store.state.account.copy.name}}
      </router-link>
    </div>
  </div>
</Header>
</template>

<script>
export default {
  created() {
    console.log(this.$store.state.auth);
  }
};
</script>

<style lang="less" scoped>
  @import '../../less/mgn-variables.less';

  .ivu-dropdown .ivu-dropdown-rel{
    height:64px;
  }
  .topnav{
    color: @white;
    position: fixed;
    top: 0;
    width: 100%;
    z-index:500;
    &.ivu-layout-header{
      background-color: @primary-color !important;
    }
    .header-brand{
      display: block;
      width: 118px;
      height: auto;
      transform: translate(-50%, 0);
      left: 50%;
      position: absolute;
      .logo{
        width: 118px;
        display: block;
        height: 64px;
        background-position: center;
        background-image: url('/img/magnet_logo_white.svg');
        background-repeat: no-repeat;
        //.image-2x('/img/magnet_logo_white.svg', 118px, 22px);
      }
    }
    .menu-item{
      a{
        color: @white;
      }
      &-icon{
        float: left;
        font-size: 28px;
        line-height: 59px;
      }
      &-name{
        font-size:10px;
        opacity: 0.6;
        display:block;
        line-height:1;
        margin-bottom:2px;
      }
      &-text{
        float:right;
        line-height:1;
        margin-top:20px;
        margin-left:4px;
        font-size:12px;
      }
      &-link{
        display:block;
        line-height:1;
      }
    }
    .user-menu{
      float:right;
      margin-left:12px;
    }
    .account-selection{
      float:right;
    }

    .ivu-dropdown-item{
      padding: 8px 24px;
      a{
        color: @text-color;
        font-size:14px;
      }
    }
  }
</style>
